export default __webpack_public_path__ + "img/1_3-93dc1c93.png";